import { useMemo } from 'react'

import { getHelloSitesUrl } from 'api/utils/paths'
import { basePath } from 'interfaces/constants'

import { useRouterExtend } from './useRouterExtend'

export function useHelloSite(ignoreLocal = false) {
  const { locale, asPath } = useRouterExtend()

  const hellosite = useMemo(
    () => `${getHelloSitesUrl(locale, ignoreLocal)}${basePath}`,
    [locale, ignoreLocal],
  )

  const hellositeFullPath = useMemo(() => `${hellosite}${basePath}${asPath}`, [
    hellosite,
    asPath,
  ])

  return useMemo(() => ({ hellosite, hellositeFullPath }), [
    hellosite,
    hellositeFullPath,
  ])
}
